<template>
  <common-dialog ref="dialog" width="80%" title="打印快递单" :data="data" :confirm-on-close-change="false"
    @closed="onClosed">
    <template slot="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="选择打印机">
            <el-select v-model="data.printer" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in printerList" :key="k" :label="i.name" :value="i.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item label="是否拆单">
            <el-checkbox v-model="data.separate" @change="onSeparateChange"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="0">
            <div style="display: flex;">
              <div style="margin-right: 10px;">每笔订单获取</div>
              <el-input-number v-model="data.separateNumber" :min="2" :precision="0"
                :disabled="!data.separate"></el-input-number>
              <div style="margin-left: 10px;">个电子面单号</div>
            </div>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="剩余单数">
            <span style="color: #D9001B;">{{ data.surplusCount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="19">
          <el-form-item label="申请打印数">
            <span style="color: #D9001B;">{{ data.printCount }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="5" v-if="!data.isPrint">
          <el-form-item label="自动发货">
            <el-checkbox v-model="data.autoSend"></el-checkbox>
          </el-form-item>
        </el-col> -->
        <el-col :span="19">
          <el-form-item label="默认发货地址" label-width="100px">
            <el-select v-model="data.address" placeholder="请选择" @change="onAddressChange" clearable>
              <el-option v-for="(i, k) in senderAddress" :key="k" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="快递模板" label-width="100px">
            <el-select v-model="data.templateId" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in templateList" :key="k" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="data.rows" border class="merge-table" max-height="500">
            <el-table-column prop="date" label="收货地址" min-width="350">
              <template slot-scope="{row}">
                <!-- <div class="merge-item" v-if="row.Id != 2">周**，17****199，江苏省苏州市吴中区江苏省苏*******建工恒泰项目部</div> -->
                <!-- <div class="merge-item" v-else>
                  <div class="badge badge-merge">合单4</div>
                  <span>陈**, 172*****406，江苏省/南通市/如东县/双逸创业园区******</span>
                </div> -->
                <div class="merge-item">
                  <span>{{ row.receiverAddress.fullName }}，</span>
                  <span>{{ row.receiverAddress.mobilePhone }}，</span>
                  <span>{{ row.receiverAddress.province }}</span>
                  <span>{{ row.receiverAddress.city }}</span>
                  <span>{{ row.receiverAddress.district }}</span>
                  <span>{{ row.receiverAddress.detailAddress }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="订单号" width="200">
              <template slot-scope="{row}">
                <!-- <template v-if="row.Id == 2">
                  <div class="merge-item">240318-529897952651816</div>
                  <div class="merge-item">240318-529897952651000</div>
                  <div class="merge-item">240318-529897952651111</div>
                </template> -->
                <!-- <template v-else>
                  <div class="merge-item">240316-535486831503318</div>
                </template> -->
                <div class="merge-item">{{ row.orderNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="Field8" label="运单号" width="200">
              <div slot-scope="{row}" class="merge-item">
                <template v-if="row.logistics && row.logistics.length > 0">
                  <!-- <div v-for="(i1, k1) in row.Field8" :key="k1">
                    <div>{{ i1.Field8_1 }}：</div>
                    <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
                  </div> -->
                  <div v-for="(i1, k1) in row.logistics" :key="k1">
                    <div>{{ i1.waybillCode }}</div>
                  </div>
                </template>
                <span v-else>无</span>
              </div>
            </el-table-column>
            <el-table-column prop="address" label="打印状态" width="90">
              <div slot-scope="{row}" class="merge-item">
                <span v-if="row.isPrint">已打印</span>
                <span v-else>未打印</span>
              </div>
            </el-table-column>
            <el-table-column prop="address" label="发货状态" width="90">
              <template slot-scope="{row}">
                <div class="merge-item">
                  <span v-if="row.orderStatus == 1">待发货</span>
                  <span v-if="row.orderStatus == 2">已发货待签收</span>
                  <span v-if="row.orderStatus == 3">已签收</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90" v-if="data.isPrint">
              <template slot-scope="{row}">
                <el-button type="text" @click="onPrintAfresh(row)">重新打印</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <template slot="footer">
      <div v-if="isDev" style="display: inline-block;margin-right: 10px;">
        <span style="margin-right: 10px;">预览</span>
        <el-switch v-model="preview"></el-switch>
      </div>
      <template v-if="!data.isPrint">
        <el-button v-if="data.autoSend" type="success" @click="onPrintAndSend">获取单号打印并发货</el-button>
        <el-button v-else type="primary" @click="onPrint">获取新单号并打印</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="onBatchPrintAfresh()">
          {{ data.rows.length > 1 ? '批量重新打印' : '重新打印' }}
        </el-button>
        <!-- <el-button type="warning" @click="onAddNewNumberPrint">添加新单号打印</el-button> -->
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import { nanoid } from 'nanoid';
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/pdd/malladdresses').default,
      malladdressesApi: require('@/api/pdd/malladdresses').default,
      logisticsApi: require('@/api/pdd/logistics').default,
      waybillsApi: require("@/api/pdd/waybills").default,
      orderApi: require("@/api/pdd/order").default,
      socket: null,
      data: {
        id: 0,
        isPrint: false, //是否已打印
        printer: "", //打印机
        separate: false, //拆单
        separateNumber: 2,
        surplusCount: 0, //剩余单数
        printCount: 0, //申请打印数
        autoSend: false, //自动发货
        address: null, //默认发货地址
        templateId: null,
        rows: []
      },
      senderAddress: [],
      templateList: [],
      //打印数据
      requestId: nanoid(10),
      printerList: [],
      printData: [],
      waybillList: [],
      preview: false
    };
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV == "development";
    }
  },
  mounted() { },
  methods: {
    setData(data) {
      console.log("setData", data);
      this.data.printCount = data.rows.length;
      this.data.isPrint = data.isPrint;
      this.data.autoSend = data.autoSend;
      this.data.rows = data.rows;
      this.waybillList = data.waybillList;
      this.getSenderAddress();
      this.onInitWs();
    },
    getSenderAddress() {
      this.senderAddress = [];
      this.templateList = [];
      return new Promise((resolve, reject) => {
        this.malladdressesApi.getSender().then(res => {
          if (!res.errorCode) {
            this.senderAddress = res.data.map(x => {
              var addr = x.senderAddress;
              var address = x.logisticsCompany + " " + addr.fullName + " " + addr.mobilePhone + " " + addr.country +
                addr.province + addr.city + addr.district + addr.detailAddress;
              return { id: x.id, name: address, data: x }
            });
          }
          resolve(res);
        }).catch(err => {
          reject(err)
        })
      })
    },
    onAddressChange(val) {
      var address = this.senderAddress.find(x => x.id == val);
      console.log("address", address)
      var waybill = this.waybillList.find(x => x.logisticsId == address.data.logisticsId);
      console.log("waybill", waybill)
      if (waybill) {
        this.data.surplusCount = waybill.quantity;
        this.getTemplates(address.data.wpCode);
      }
    },
    getTemplates(code) {
      return new Promise((resolve, reject) => {
        this.logisticsApi.standardtemplates(code).then(res => {
          if (!res.errorCode) {
            this.data.templateId = null;
            res.data = res.data.filter(x => x.standardTemplateId != null)
            this.templateList = res.data.map(x => {
              return { id: x.id, name: x.standardTemplateName, url: x.standardTemplateUrl }
            });
          }
          resolve(res);
        }).catch((err) => {

          reject(err)
        })
      })
    },
    onSeparateChange() {
      this.data.separateNumber = 2;
    },
    onClosed() {
      if (this.socket) this.socket.close();
      this.senderAddress = [];
      this.templateList = [];
      this.printerList = [];
      this.printData = [];
    },
    //打印
    /** 初始化websocket (要打开pdd打印组件，websocket才能连接上) */
    onInitWs() {
      this.socket = new WebSocket("ws://127.0.0.1:5000");
      // 添加WebSocket事件监听器
      this.socket.addEventListener("open", this.onSocketOpen);
      this.socket.addEventListener("message", this.onSocketMessage);
      this.socket.addEventListener("close", this.onSocketClose);
      this.socket.addEventListener("error", this.onSocketError);
      // console.log("初始化", this.socket);
    },
    onSocketOpen() {
      console.log("WebSocket连接已打开");
      //获取本地打印机列表
      let data = {
        cmd: "getPrinters",
        requestID: this.requestId,
        version: "1.0",
      };
      this.socket.send(JSON.stringify(data));
    },
    onSocketMessage(event) {
      const result = JSON.parse(event.data);
      console.log("收到WebSocket消息:", result);
      console.log("预览:", result.previewURL);
      // console.log(result.cmd);
      if (result.cmd == "getPrinters") {
        this.printerList = result.printers;
      }
      if (result.cmd == "PrintResultNotify") {
        console.log("打印结果通知", result);
        if (result.taskStatus == "failed") {
          this.$message.error("打印失败");
        } else {
          this.$message.success("打印成功");
          this.close();
        }
        // if (result.taskStatus == "success") {
        //   this.$message.success("打印成功");
        // }
      }
    },
    onSocketClose() {
      console.log("WebSocket连接已关闭");
    },
    onSocketError(event) {
      console.error("WebSocket连接错误:", event);
    },
    onPrint() {
      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      if (!this.data.address) {
        this.$message.warning("请选择默认发货地址");
        return;
      }

      if (!this.data.templateId) {
        this.$message.warning("请选择快递模板");
        return;
      }

      var data = {
        orderNumbers: this.data.rows.map(x => x.orderNumber),
        mallSenderAddressId: this.data.address,
        pddPrintStandardTemplateId: this.data.templateId
      };
      console.log("打印", data);

      this.waybillsApi.batchWaybill(data).then(res => {
        this.printData = [];
        var waybillCodes = [];

        var address = this.senderAddress.find(x => x.id == this.data.address);
        console.log("address", address);

        res.data.forEach(x => {
          this.printData.push({
            object_id: x.object_id,
            parent_waybill_code: x.parent_waybill_code,
            print_data: JSON.parse(x.print_data),
            waybill_code: x.waybill_code
          })

          var order = this.data.rows.find(o => o.orderNumber == x.object_id);
          waybillCodes.push({
            orderId: order.id,
            orderType: 0,
            wpCode: address.data.wpCode,
            logisticsId: address.data.logisticsId,
            logisticsCompany: address.data.logisticsCompany,
            waybillCode: x.waybill_code
          })
        })
        console.log("onPrint", JSON.parse(JSON.stringify(this.printData)));
        if (waybillCodes.length > 0) {
          this.orderApi.postWaybillCode({ waybillCodes }).then(res => {
            if (res > 0) {
              this.$message.success("获取电子面单成功，开始打印");
              this.$emit("reload");
              this.startPrint().then();
            } else {
              this.$message.error("电子面单保存失败")
            }
          })
        }
      })
    },
    onPrintAndSend() {
      console.log("打印并发货");

      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      if (!this.data.address) {
        this.$message.warning("请选择默认发货地址");
        return;
      }

      if (!this.data.templateId) {
        this.$message.warning("请选择快递模板");
        return;
      }

      var data = {
        orderNumbers: this.data.rows.map(x => x.orderNumber),
        mallSenderAddressId: this.data.address,
        pddPrintStandardTemplateId: this.data.templateId
      };
      console.log("打印", data);

      this.waybillsApi.batchWaybill(data).then(waybillsres => {
        this.printData = [];
        var waybillCodes = [];

        var address = this.senderAddress.find(x => x.id == this.data.address);
        console.log("address", address);

        waybillsres.data.forEach(x => {
          this.printData.push({
            object_id: x.object_id,
            parent_waybill_code: x.parent_waybill_code,
            print_data: JSON.parse(x.print_data),
            waybill_code: x.waybill_code
          })

          var order = this.data.rows.find(o => o.orderNumber == x.object_id);
          waybillCodes.push({
            orderId: order.id,
            orderType: 0,
            wpCode: address.data.wpCode,
            logisticsId: address.data.logisticsId,
            logisticsCompany: address.data.logisticsCompany,
            waybillCode: x.waybill_code
          })
        })
        console.log("onPrint", JSON.parse(JSON.stringify(this.printData)));
        this.orderApi.postWaybillCode({ waybillCodes }).then(res => {
          if (res > 0) {
            this.$message.success("获取电子面单成功，开始打印");
            this.$emit("reload");
            this.startPrint().then(() => {
              var sendData = [];
              waybillsres.data.forEach(x => {
                sendData.push({
                  logisticsId: address.data.logisticsId,
                  orderSn: x.object_id,
                  trackingNumber: x.waybill_code,
                });
              });

              this.logisticsApi.postSendonline({ sendData }).then(sendres => {
                if (sendres.data.length == 0) {
                  this.$message.success("发货成功");
                } else {
                  var html = '';
                  sendres.data.forEach(x => { html += `<div>${x.label}：${x.error}</div>`; });
                  var msg = `<div style="max-height: 260px;overflow-y: auto;">${html}</div>`;
                  this.$alert(msg, '发货失败', { dangerouslyUseHTMLString: true, type: 'error' });
                }
              }).catch(() => {

              })
            })
          } else {
            this.$message.error("电子面单保存失败")
          }
        })
      })
    },
    onPrintAfresh(row) {
      if (!(row.waybillCodes && row.waybillCodes.length > 0)) {
        this.$message.error("当前无运单号，请重新取号打印");
        return;
      }
      console.log("重新打印", row);
      this.onBatchPrintAfresh(row);
    },
    onBatchPrintAfresh(row = null) {
      if (!this.data.printer) {
        this.$message.warning("请选择打印机")
        return;
      }

      var rows = [];
      if (row == null) {
        rows = this.data.rows;
      } else {
        rows = [row];
      }
      var models = [];
      rows.forEach(o => {
        o.waybillCodes.forEach(code => {
          models.push({
            orderNumber: o.orderNumber,
            wpCode: code.wpCode,
            waybillCode: code.waybillCode
          })
        })
      })
      console.log("批量重新打印", models);
      if (models.length == 0) {
        this.$message.warning("当前无运单号，请重新取号打印");
        return;
      }
      this.waybillsApi.batchReprint({ models }).then(res => {
        this.printData = [];
        res.forEach(x => {
          this.printData.push({
            object_id: x.object_id,
            parent_waybill_code: x.parent_waybill_code || null,
            print_data: JSON.parse(x.print_data),
            waybill_code: x.waybill_code
          })
        })
        console.log("onBatchPrintAfresh", JSON.parse(JSON.stringify(this.printData)));

        this.startPrint().then();
      })
    },
    onAddNewNumberPrint() {
      console.log("添加新单号打印");

    },
    startPrint() {
      // var addr = this.senderAddress.find(x => x.id == this.data.address);
      // var sender = {
      //   address: {
      //     city: addr.city,
      //     detail: addr.detailAddress,
      //     district: addr.district,
      //     province: addr.province
      //   },
      //   mobile: addr.mobilePhone,
      //   name: addr.fullName,
      // }

      // console.log("this.socket", this.socket);
      return new Promise((resolve, reject) => {
        var data = {
          cmd: "print",
          requestID: this.requestId,
          task: {
            documents: [],
            notifyType: ["print"],
            preview: this.preview,
            previewType: "image",
            printer: this.data.printer,
            taskID: new Date().getTime(),
          },
          version: "1.0"
        }

        var docs = [];

        this.printData.forEach(x => {
          docs.push({
            documentID: x.waybill_code,
            contents: [
              {
                // addData: {
                //   sender: sender
                // },
                encryptedData: x.print_data.encryptedData,
                signature: x.print_data.signature,
                templateUrl: x.print_data.templateUrl,
                ver: x.print_data.ver,
              },
              // {
              //   data: {
              //     height: 240,
              //     list: custom,
              //     waterdata: {
              //       text: "这是水印"
              //     }
              //   },
              //   templateURL: "111111111"
              //   // templateURL: this.fileUrl
              // }
            ]
          })
        })

        data.task.documents = docs;
        console.log("开始打印", data);
        this.socket.send(JSON.stringify(data));
        resolve();
      })
    }
  },
};
</script>